


















import { Component, Vue } from "vue-property-decorator";
import StartedAttempt from "@/components/StartedAttempt.vue";
import AttemptModule from "@/store/AttemptModule";
import ReadyAttempt from "@/components/ReadyAttempt.vue";
import FinishedAttempt from "@/components/FinishedAttempt.vue";
import AttemptModel from "@/model/AttemptModel";

@Component({
  components: {
    ReadyAttempt: ReadyAttempt,
    StartedAttempt: StartedAttempt,
    FinishedAttempt: FinishedAttempt
  }
})
export default class App extends Vue {
  async mounted() {
    await AttemptModule.handlePublicUuid();
    await AttemptModule.getAttemptUuid();
    await AttemptModule.fetchAttempt(AttemptModule.uuid);
  }
  get loaded(): boolean {
    return AttemptModule.attempt !== null;
  }

  get attempt(): AttemptModel {
    if (AttemptModule.attempt === null) {
      throw new Error("Attempt cannot be accessed before it is loaded");
    }
    return AttemptModule.attempt;
  }
}
